import {
    Component,
    Input,
    Output,
    EventEmitter
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.pug',
    styleUrls: ['./confirm.component.less']
})
export class ConfirmComponent {
    @Input() title: string = '';
    @Input() icon: string = '';
    @Input() iconWidth: number = 42;
    @Input() iconHeight: number = 42;
    @Input() message: string = '';
    @Input() innerHTML: string = '';

    _buttonOkClasses = ['btn', 'btn-primary']
    @Input() set buttonOkClasses(value: string[]) {
        if (!value) {
            return;
        }

        this._buttonOkClasses = value;
    }
    get buttonOkClasses() {
        return this._buttonOkClasses;
    }

    @Input() buttonOkLabel: string = '';

    _buttonOkInnerHTML: SafeHtml = '';
    @Input() set buttonOkInnerHTML(value: string) {
        if (!value) {
            return;
        }

        this._buttonOkInnerHTML = this._sanitizer.bypassSecurityTrustHtml(value);
    };
    get buttonOkInnerHTML(): string {
        return this._buttonOkInnerHTML as string;
    }
    
    @Input() buttonOkWarning: boolean = false;

    _buttonCancelClasses = ['btn', 'btn--transparent']
    @Input() set buttonCancelClasses(value: string[]) {
        if (!value) {
            return;
        }

        this._buttonCancelClasses = value;
    }
    get buttonCancelClasses() {
        return this._buttonCancelClasses;
    }

    @Input() buttonCancelLabel: string = '';

    _buttonCancelInnerHTML: SafeHtml = '';
    @Input() set buttonCancelInnerHTML(value: string) {
        if (!value) {
            return;
        }

        this._buttonCancelInnerHTML = this._sanitizer.bypassSecurityTrustHtml(value);
    };
    get buttonCancelInnerHTML(): string {
        return this._buttonCancelInnerHTML as string;
    }

    @Output() confirm: EventEmitter<any> = new EventEmitter();
    @Output() cancel: EventEmitter<any> = new EventEmitter();

    constructor(
        private _sanitizer: DomSanitizer
    ) {
    }

    onConfirm() {
        this.confirm.emit();
    }

    onCancel() {
        this.cancel.emit();
    }
}
